// https://www.flaticon.com/free-icon/loupe_709592?term=search&page=1&position=5&page=1&position=5&related_id=709592&origin=search
import { memo, type ReactElement } from 'react'

function SearchIcon (): ReactElement {
  return (
    <button type="submit" className="w-3 h-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        enableBackground="new 0 0 512 512"
        version="1.1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <path
          d="M225.474 0C101.151 0 0 101.151 0 225.474c0 124.33 101.151 225.474 225.474 225.474 124.33 0 225.474-101.144 225.474-225.474C450.948 101.151 349.804 0 225.474 0zm0 409.323c-101.373 0-183.848-82.475-183.848-183.848S124.101 41.626 225.474 41.626s183.848 82.475 183.848 183.848-82.475 183.849-183.848 183.849z"
          fill="#a9a9a9"
        />
        <path
          d="M505.902 476.472L386.574 357.144c-8.131-8.131-21.299-8.131-29.43 0-8.131 8.124-8.131 21.306 0 29.43l119.328 119.328A20.74 20.74 0 00491.187 512a20.754 20.754 0 0014.715-6.098c8.131-8.124 8.131-21.306 0-29.43z"
          fill="#a9a9a9"
        />
      </svg>
    </button>
  )
}

export default memo(SearchIcon)
